"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useCiselnik_1 = __importDefault(require("../../../../hooks/useCiselnik"));
var RemovableDropdown_1 = __importDefault(require("../../inputs/RemovableDropdown"));
var JazykySpecializace_1 = __importStar(require("./JazykySpecializace"));
var DropDownWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"])));
var specializaceLens = ramda_1.lensProp('specializace');
var viewPodrizene = function (jazyky) { return ramda_1.view(specializaceLens, jazyky) || []; };
var filterAvailable = function (selectedIds) { return ramda_1.filter(function (specializace) { return !ramda_1.includes(specializace.id, selectedIds); }); };
var mapToOptions = ramda_1.map(function (specializace) { return ({ value: specializace.id, label: specializace.nazev }); });
var Jazyky = function (_a) {
    var jazyk = _a.jazyk, onChange = _a.onChange, onRemove = _a.onRemove, options = _a.options, showRemove = _a.showRemove, specs = _a.specs, readOnly = _a.readOnly, isPreklUkon = _a.isPreklUkon;
    var _b = useCiselnik_1.default('jazykSpecializace'), loading = _b.loading, error = _b.error, ciselnikSpecializace = _b.data;
    var getSpecializace = function () {
        if ((specs === null || specs === void 0 ? void 0 : specs.length) && !ciselnikSpecializace)
            return specs;
        return ciselnikSpecializace;
    };
    if (loading && !(specs === null || specs === void 0 ? void 0 : specs.length)) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error && !(specs === null || specs === void 0 ? void 0 : specs.length)) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    var handleChange = function (index) { return function (specializaceId) {
        var _a;
        var specializace = (_a = getSpecializace()) === null || _a === void 0 ? void 0 : _a.find(function (j) { return j.id === specializaceId; });
        onChange(__assign(__assign({}, jazyk), { specializace: ramda_1.set(ramda_1.lensIndex(index), specializace, jazyk.specializace) }));
    }; };
    var handleRemove = function (index) { return function () {
        onChange(__assign(__assign({}, jazyk), { specializace: ramda_1.remove(index, 1, jazyk.specializace) }));
    }; };
    var AddSpecializaceAction = function () {
        onChange(ramda_1.over(specializaceLens, ramda_1.append({}), jazyk));
    };
    return (react_1.default.createElement(DropDownWrapper, null,
        react_1.default.createElement(JazykySpecializace_1.StyledRemovableDiv, { key: "jazyk-" + jazyk.id, readOnly: readOnly },
            react_1.default.createElement(RemovableDropdown_1.default, { name: "jazyk-" + jazyk.id, placeholder: "Vyberte jazyk", value: jazyk.id, onChange: onChange, onRemove: onRemove, loadOptions: options, showAdd: !isPreklUkon && !readOnly, showRemove: showRemove && !readOnly, addString: "+ Specializace", onAdd: AddSpecializaceAction, disabled: readOnly, readOnly: readOnly })),
        ramda_1.addIndex(ramda_1.map)(function (jazykySpecializace, index) {
            var usedIds = ramda_1.without([jazykySpecializace.id], ramda_1.pluck('id', jazyk.specializace || []));
            var optionsSpecializace = ramda_1.pipe(filterAvailable(usedIds), mapToOptions)(getSpecializace() || []);
            return (react_1.default.createElement(JazykySpecializace_1.default, { key: jazykySpecializace.id || "create-" + index, jazykySpecializace: jazykySpecializace, onChange: handleChange(index), onRemove: handleRemove(index), options: function () { return Promise.resolve(optionsSpecializace); }, readOnly: readOnly }));
        }, viewPodrizene(jazyk))));
};
Jazyky.defaultProps = {
    showRemove: true,
    specs: undefined,
    readOnly: undefined,
    isPreklUkon: undefined,
};
exports.default = Jazyky;
var templateObject_1;
